import { CHECK_IN_LOGS_API_ENDPOINTS } from '@/constants';
import { ICheckInLog, ICheckInLogSearchingPayload } from '@/features/check-in-logs/interfaces';
import { api } from '@/services';
import { ApiResponse, PagedResponse } from '@/types';

const CheckInLogService = {
  CheckInLogsSearching: async (
    payload: ICheckInLogSearchingPayload,
  ): Promise<PagedResponse<ICheckInLog>> => {
    const response = await api.post<ApiResponse<PagedResponse<ICheckInLog>>>(
      CHECK_IN_LOGS_API_ENDPOINTS.CHECK_IN_LOGS_SEARCHING,
      payload,
    );
    return response.data.data;
  },
};

export default CheckInLogService;
